module.exports = __webpack_public_path__ + "img/logo.66d57bf1.png";